<app-base-modal
  [title]="'Артикулы конкурента'"
  [showStateToggle]="isValid()"
>
  <div class="competitor-articles-wrapper">
    @if (isLoading) {
      <app-loader/>
    }
    <mat-accordion [multi]="true">
      @for (competitorArticleForm of competitorArticleFormGroups(); track $index) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <app-competitor-articles-accordion-title
                class="competitor-articles-title"
                [competitorArticleData]="competitorArticlesData()[$index]"
                [isEditModeActive]="isEditModeActive"
                (deleteData)="handleDeleteData($index)"
              />
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-competitor-articles-form
            [competitorBrandId]="competitorBrandId()"
            [competitorArticleForm]="competitorArticleForm"
            [competitorArticleData]="competitorArticlesData()[$index]"
            [noFirstData]="noFirstData()"
            [isEditModeActive]="isEditModeActive"
            [productGroupSelectData]="productGroupSelectData()"
            (updateData)="handleUpdateData($event, $index)"
            (deleteData)="handleDeleteData($index)"
          />
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      class="save-button"
      color="primary"
      [disabled]="!isValid()"
      (click)="handleAddNew()"
    >
      Добавить новый
    </button>
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
